import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/KeyFeatures/keyFeatures.component"
    ).then((module) => ({ default: module.KeyFeatures }))
);
